<template>
  <v-flex>
    <v-tabs
      v-model="activeTab"
      grow
    >
      <v-tab :key="1">{{ $t('Date') }}</v-tab>
      <v-tab :key="2">{{ $t('Time') }}</v-tab>
      <v-tab-item :key="1">
        <v-date-picker
          v-model="date"
        />
      </v-tab-item>
      <v-tab-item :key="2">
        <v-time-picker
          v-model="time"
          :allowed-seconds="allowedSeconds"
          :use-seconds="true"
          format="24hr"
        />
      </v-tab-item>
    </v-tabs>

    <v-flex
      class="text-xs-center pt-2 pb-2 tabs-footer">
      <v-btn
        color="primary"
        @click="confirm">{{ $t('Confirm') }}
      </v-btn>
    </v-flex>
  </v-flex>
</template>

<script>
export default {
  name: 'DateTimePicker',

  props: {
    dateTime: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      activeTab: 0,
      date: '',
      time: ''
    }
  },

  created () {
    if (!this.dateTime) {
      return
    }

    let date = this.dateTime.split(' ')
    this.date = date[0]
    this.time = date[1]
  },

  methods: {
    confirm () {
      if (this.activeTab === 0 && !this.date) {
        return
      }

      if (this.activeTab === 1 && (!this.time || !this.date)) {
        return
      }

      if (this.activeTab !== 1) {
        this.activeTab = 1
        return
      }

      let date = this.date + ' ' + this.time
      this.$emit('confirmed', date)
      this.activeTab = 0
    },

    allowedSeconds (val) {
      return val === 0
    }
  }
}
</script>

<style>
  .theme--light .tabs-footer {
    background-color: #fff;
  }
  .theme--dark .tabs-footer {
    background-color: #424242;
  }
</style>
